import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipsListComponent } from './chips-list/chips-list.component';
import { ChipComponent } from './chip/chip.component';
import { ChipNotResponsiveComponent } from './chip-notResponsive/chip-notResponsive.component';
import { ChipsListNotResponsiveComponent } from './chips-list-notResponsive/chips-list-notResponsive.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ChipsListComponent, ChipComponent, ChipsListNotResponsiveComponent, ChipNotResponsiveComponent],
  exports: [
    ChipsListComponent, ChipComponent, ChipsListNotResponsiveComponent, ChipNotResponsiveComponent
  ]
})
export class ChipsModule { }



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/chips/chips.module.ts